import TranslateIcon from '@mui/icons-material/Translate';
import LanguageIcon from '@mui/icons-material/Language';
import Check from '@mui/icons-material/Check';
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { useEffect, useState } from 'react';
import { LocalesConfig } from '../../../locales/locales';
import { useTranslation } from 'react-i18next';

const LanguageMenu = (): JSX.Element => {
  const { i18n } = useTranslation();

  const [anchorEl, setAnchorEl] = useState(null);

  const [language, setLanguage] = useState( i18n.language );

  useEffect(() => {
    i18n.changeLanguage(language);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleMenuClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const changeLanguage = (language: string) => () => {
    i18n.changeLanguage(language);
    setLanguage(language);
    localStorage.setItem("lng", language);
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        size="large"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={handleMenuClick}
        color="inherit"
      >
        <TranslateIcon />
        <LanguageIcon />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {LocalesConfig.languageNames.map(lang => (
          <MenuItem key={lang} onClick={changeLanguage(LocalesConfig.languageMap[lang])}>
            {LocalesConfig.languageMap[lang] === language ? (
              <ListItemIcon>
                <Check />
              </ListItemIcon>
            ) : (
              <></>
            )}
            <ListItemText inset={LocalesConfig.languageMap[lang] !== language}>{lang}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default LanguageMenu;
